import { apiRequestWithChecks } from "./api";

export const language = {
    getLanguages: function (token) {
        return apiRequestWithChecks(
            "GET",
            "/api/language/list",
            { Authorization: "Bearer " + token },
            null,
            false  // Language list response may not have a success field — suppress error toast
        );
    },

    translateText: function (token, text, targetLanguage) {
        return apiRequestWithChecks(
            "POST",
            "/api/language/translate",
            { Authorization: "Bearer " + token },
            { text, targetLanguage, format: "text" },
            false  // TranslateResponse has no success field — suppress error toast
        );
    },
};
